import { render } from "./ReferralSourcesList.vue?vue&type=template&id=1872c008&scoped=true"
import script from "./ReferralSourcesList.vue?vue&type=script&lang=js"
export * from "./ReferralSourcesList.vue?vue&type=script&lang=js"

import "./ReferralSourcesList.vue?vue&type=style&index=0&id=1872c008&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1872c008"]])

export default __exports__